import React from "react";
import styles from './unlinkHeader.module.scss';
import {ReactComponent as Icon} from "../../../../../assets/promos&items/openCloseRightMenuIcon.svg";
import {useDispatch} from "react-redux";
import {toggleUnlinkPromotionsItemsPanel} from "../../../../../store/actionCreators/promotionsItemsCreators";

interface Props {
    isOpen: boolean;
}

export const UnlinkHeader = (props: Props) => {
    const dispatch = useDispatch();
    const setOpenMenu = () => {
        dispatch(toggleUnlinkPromotionsItemsPanel(!props.isOpen));
    }
    return (
        <div className={`${styles.header} ${props.isOpen ? styles.is_open_menu: ''}`}>
            <div className={`${props.isOpen ? styles.is_open : ''} ${styles.right_menu_collapse_icon}`} onClick={setOpenMenu}>
                <Icon/>
            </div>
            <div>
                UNLINKED
            </div>
        </div>
    )
}